export default "__VITE_ASSET__72acebd9__"